module.exports = __webpack_public_path__ + "static/img/none.81e58499.png";